import angular from "angular"

export default angular.module("r2PanelModule", [])